import { render, staticRenderFns } from "./HistoricoInadimplencia.vue?vue&type=template&id=3c603f8d&scoped=true&"
import script from "./HistoricoInadimplencia.vue?vue&type=script&lang=js&"
export * from "./HistoricoInadimplencia.vue?vue&type=script&lang=js&"
import style0 from "./HistoricoInadimplencia.vue?vue&type=style&index=0&id=3c603f8d&scoped=true&lang=css&"
import style1 from "./HistoricoInadimplencia.vue?vue&type=style&index=1&lang=sass&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c603f8d",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VIcon})
